import React from 'react'
import { OverflowTooltip } from '../../apps/professional-app/fa/common/OverflowTooltip/OverflowTooltip'

export interface MeetingTitleDisplayProps {
  title?: string
}

export const MeetingTitleDisplay: React.FC<MeetingTitleDisplayProps> = ({ title }) => {
  return (
    <OverflowTooltip>
      <h6 className='meeting-title'>{title || 'Untitled meeting.'}</h6>
    </OverflowTooltip>
  )
}
